import workspaceQuery from '../../queries/purchases/DebitNoteDocumentWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/purchases/DebitNoteDocumentQuery.graphql';
import fragment from 'graphql/fragments/purchases/DebitNoteDocumentFragment.graphql';

import generateMutation from 'graphql/mutations/purchases/DebitNoteDocumentGenerateMutation.graphql';
import generateRangeMutation from 'graphql/mutations/purchases/DebitNoteDocumentGenerateRangeMutation.graphql';
import reprintMutation from 'graphql/mutations/purchases/DebitNoteDocumentReprintMutation.graphql';

import * as printFunctions from '../../../actions/purchasing/DebitNoteDocumentAction';
import { purchaseDocument } from '../../../utils/mailMergeFields';
import { ReportType } from '../../schema/p4types';
import { DocumentEntityType, EntityType } from '../../../@types/entityTypes';

const DebitNoteDocument: EntityType & DocumentEntityType = {
  type: 'DebitNoteDocument',
  title: 'Debit Note Document',
  formUrl: '/Purchasing/DebitNoteDocument/Form',
  formTitle: 'Print Debit Note Documents',
  workspaceUrl: '/Purchasing/DebitNoteDocument/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  generate: generateMutation,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  fragment: fragment,
  printFunctions: printFunctions,
  screenReference: 'PRINT_DEBIT_NOTE_DOCUMENT',
  configuration: {
    title: 'Debit Note',
    field: 'debitNoteDocumentDefault',
    reportType: ReportType.DebitNote,
    receiveFlag: 'receiveDebitNoteDocument',
  },
  operations: 0,
  mergeFields: purchaseDocument,
};

export default DebitNoteDocument;
